import { createContext, useContext } from 'react';
export const EditingContext = createContext({});
export const useEditing = () => useContext(EditingContext);
